import script from "./UCEmptyList.vue?vue&type=script&setup=true&lang=js"
export * from "./UCEmptyList.vue?vue&type=script&setup=true&lang=js"

import "./UCEmptyList.vue?vue&type=style&index=0&id=cc6ad05e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc6ad05e"]])

export default __exports__